module.exports = __webpack_public_path__ + "static/flags/EN-4b1ac31a236b81829c9a34a3ef44f47d.gif";